import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import apiClient from '../api/client';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(location.search);
            const code = params.get('code');

            if (code) {
                try {
                    const response = await apiClient.post('/auth/callback', { code });
                    const { token, user } = response.data;
                    login(token, user);
                    navigate('/'); // Back to dashboard
                } catch (error) {
                    console.error("Auth callback failed", error);
                    alert("Authentication failed. " + (error.response?.data?.detail || ""));
                    navigate('/login');
                }
            } else {
                navigate('/login');
            }
        };

        handleCallback();
    }, [location, login, navigate]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                background: '#0a0e17',
                color: 'white',
            }}
        >
            <CircularProgress sx={{ color: '#00d4aa', mb: 4 }} />
            <Typography variant="h5">Authenticating with Whop...</Typography>
        </Box>
    );
};

export default AuthCallback;
